import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import TitledTextWithModal from "@coworker/apprestructured/src/task-management/components/TitledTextWithModal/TitledTextWithModal";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import { FixaTextArea } from "@coworker/apprestructured/src/shared/wrappers/FixaTextArea/FixaTextArea";

function TitledTextWithModalDemo() {
  const [title, setTitle] = useState("This is the title");
  const [text, setText] = useState("This is the text");
  const [caption, setCaption] = useState("This is the Caption");
  const [firstLine, setFirstLine] = useState("This is the first line");
  const [subsequentLines, setSubsequentLines] = useState([
    "This is the second line",
    "This is the third line",
  ]);

  return (
    <Demo>
      <Name>TitledTextWithModal</Name>
      <Highlight>
        <TitledTextWithModal
          title={title}
          description={text}
          modalContent={
            <div>
              <div>
                <strong>{caption}</strong>
              </div>
              <div>{firstLine}</div>
              {subsequentLines.map((line, idx) => (
                <div key={idx}>{line}</div>
              ))}
            </div>
          }
        />
      </Highlight>
      <Actions>
        <FixaInputField
          label="title"
          type="text"
          id="titledtextwithmodaldemo-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FixaInputField
          label="description"
          type="text"
          id="titledtextwithmodaldemo-text"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <FixaInputField
          label="Modal caption"
          type="text"
          id="titledtextwithmodaldemo-caption"
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
        />
        <FixaInputField
          label="Modal first line"
          type="text"
          id="titledtextwithmodaldemo-first-line"
          value={firstLine}
          onChange={(e) => setFirstLine(e.target.value)}
        />
        <FixaTextArea
          id="titledtextwithmodaldemo-subsequent-lines"
          label="Modal subsequent lines (one per line)"
          rows={5}
          value={subsequentLines.join("\n")}
          onChange={(e) =>
            setSubsequentLines(
              e.target.value === "" ? [] : e.target.value.split("\n")
            )
          }
        />
      </Actions>
    </Demo>
  );
}

export default memo(TitledTextWithModalDemo);
